// ハチ公くん マウス連動アニメーション (Issue #20)
//
// - default: blink (CSS のみでループ、JS 不要)
// - footer 内でハチ公より左にマウス → left-walk / 右 → right-walk
// - ハチ公に hover → paw (お手)
// - ハチ公を click → jump (1回再生して元の状態に復帰)
const STATES = ["is-blink", "is-walk-left", "is-walk-right", "is-paw", "is-jump"]

function init() {
  const sprite = document.querySelector(".footer__hachiko-sprite")
  const footer = document.querySelector(".footer")
  if (!sprite || !footer) return
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

  let hovering = false
  let jumping = false
  let baseState = "is-blink" // hover/jump していない時の状態

  const setState = (state) => {
    if (sprite.classList.contains(state)) return
    STATES.forEach((s) => sprite.classList.remove(s))
    sprite.classList.add(state)
  }

  const applyState = () => {
    if (jumping) return
    setState(hovering ? "is-paw" : baseState)
  }

  // 反応ゾーン = footer の矩形を「ハチ公の頭上」まで上に拡張した領域。
  // ハチ公は position: absolute で footer からはみ出ているので、
  // footer 要素の mousemove だけだと真横にマウスを置いても反応しない。
  // document 全体で拾ってゾーン判定する (透明なあて板だと上のリンクを塞ぐため)
  const ZONE_MARGIN = 16 // ハチ公の頭上に足す余裕 (px)

  // タイムスタンプ式スロットル (rAF だとページ非表示中に予約が残って詰まる)
  const THROTTLE_MS = 50
  let lastMove = 0
  document.addEventListener("mousemove", (event) => {
    const now = performance.now()
    if (now - lastMove < THROTTLE_MS) return
    lastMove = now

    const footerRect = footer.getBoundingClientRect()
    const spriteRect = sprite.getBoundingClientRect()
    const zoneTop = Math.min(footerRect.top, spriteRect.top) - ZONE_MARGIN
    const inZone = event.clientY >= zoneTop && event.clientY <= footerRect.bottom

    if (!inZone) {
      baseState = "is-blink"
    } else if (event.clientX < spriteRect.left) {
      baseState = "is-walk-left"
    } else if (event.clientX > spriteRect.right) {
      baseState = "is-walk-right"
    } else {
      baseState = "is-blink"
    }
    applyState()
  })

  // マウスがウィンドウ外に出たら待機に戻す
  document.documentElement.addEventListener("mouseleave", () => {
    baseState = "is-blink"
    applyState()
  })

  // hover でお手
  sprite.addEventListener("mouseenter", () => {
    hovering = true
    applyState()
  })

  sprite.addEventListener("mouseleave", () => {
    hovering = false
    applyState()
  })

  // click でジャンプ (再生し終わったら元に戻る)
  sprite.addEventListener("click", () => {
    if (jumping) return
    jumping = true
    setState("is-jump")
  })

  sprite.addEventListener("animationend", (event) => {
    if (event.animationName !== "hachiko-jump") return
    jumping = false
    applyState()
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init)
} else {
  init()
}
